export enum FaultCategory {
  System = 'System',
  Gateway = 'Gateway',
  Device = 'Device',
  Connector = 'Connector',
}
